/* eslint-disable no-unused-vars */
import React, { useMemo } from 'react';
import * as S from './AdvancedAppInstallPostbackPage.styled';
import { LocalizationLinkedList, AppInstallPostbackForm, Loader, ErrorComponent } from 'components';
import { advancedLocalizationPages } from 'constants';
import { routes } from 'config';
import { getUrl } from 'utils';
import { manageAppsAPI } from 'services/manageApps.service';
import { useSelector } from 'react-redux';

const pba_id = 'c490cd1d-72a5-40ad-9899-b42b3fe4cc33';
const AdvancedAppInstallPostbackPage = () => {
  const pages = useMemo(
    () =>
      advancedLocalizationPages.map((page) => {
        return { ...page, link: getUrl(routes, page.url_id) };
      }),
    [],
  );

  const [savePostBackUrl, result] = manageAppsAPI.useSaveAppInstallPostbackMutation();
  const isAdvertiser = useSelector((state) => state.auth.pb_roles).includes('advertiser');

  const {
    //postBackUrl, pba_name, platform,
    isSuccess,
    isError,
    data,
  } = manageAppsAPI.useFetchAppAdvancedDataQuery(
    { pba_id, isAdvertiser },
    {
      selectFromResult: ({ data, isError, isSuccess }) => {
        return {
          postBackUrl: data?.postBackUrl,
          pba_name: data?.pba_name,
          platform: data?.platform_name,
          isError: isError,
          isSuccess: isSuccess,
          data,
        };
      },
    },
  );

  return (
    <>
      {isError && <ErrorComponent />}
      {!isSuccess && !isError && <Loader.Global delay={1} />}
      {data && (
        <S.Container>
          <h1>Advanced Settings (Local Data)</h1>
          <S.Main>
            <S.Wrap>
              <S.ListPosition>
                <LocalizationLinkedList data={pages} show={true} />
              </S.ListPosition>
              <AppInstallPostbackForm {...data} saveAction={savePostBackUrl} result={result} />
            </S.Wrap>
          </S.Main>
        </S.Container>
      )}
    </>
  );
};

export default AdvancedAppInstallPostbackPage;
